<template>
  <div class="ImageLibrary">
    <div v-for="library in libraries" :key="library.name">
      <h3>{{ library.name }}</h3>
      <div class="ImageLibrary_Images">
        <div
          v-for="image in library.images"
          :key="image.url"
          class="ImageLibrary_ImageContainer"
        >
          <img :src="image.url" v-on:click="handleSelectImage(image)" />
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import Vector from "victor";
import { Component, Vue, Prop } from "vue-property-decorator";
import { WBState } from "@/store/stateInterfaceType";
import { Store } from "vuex";
import { LIBRARIES, Library } from "@/library";

@Component({ components: {} })
export default class ImageLibrary extends Vue {
  @Prop() readonly onSelectImage!: (image: {
    url: string;
    size: Vector;
  }) => void;

  get store(): Store<WBState> {
    return this.$store;
  }

  get libraries(): Library[] {
    return LIBRARIES;
  }

  handleSelectImage(image: { url: string; size: Vector }) {
    this.onSelectImage({
      url: image.url,
      size: image.size,
    });
  }
}
</script>

<style scoped lang="scss">
.ImageLibrary_Images {
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  grid-auto-rows: 7vh;
}

.ImageLibrary_ImageContainer {
  cursor: pointer;
  background-color: var(--bg-light);
  display: flex;
  justify-content: center;
  align-items: center;
  padding: var(--margin-tiny);

  &:hover {
    background-color: var(--bg-light-hover);
  }

  img {
    width: auto;
    max-height: 7vh;
  }
}
</style>
